import React from "react";
import { FieldProps } from "@rjsf/utils";
import { UserRoleNames } from "common/authorization/policies";
import { arrayHasAtLeastOneItem } from "common/utils/arrays";
import { AuthContext } from "../../Authorization/AuthContext";
import UserSelect from "../../Inputs/UserSelect";
import { Input } from "../__styles__/Inputs";

export const UserInput = (props: FieldProps) => {
  const { account } = React.useContext(AuthContext);
  const accountGroups = account?.userGroups || [];
  const userGroupSelection: string[] =
    props.uiSchema?.["ui:userGroupSelection"] || [];

  const existingValue = props.formData || {};
  const value = existingValue ?? null;

  const includeUsers = userGroupSelection.some(
    item => typeof item === "string" && UserRoleNames.includes(item),
  );

  const userGroups = userGroupSelection.filter(item => {
    if (typeof item === "string") {
      return accountGroups.find(group => group.id === item)?.id;
    }
    return item;
  });

  const includePublicUsers = arrayHasAtLeastOneItem(userGroups);

  return (
    <Input
      id={props.idSchema.$id}
      isSubmissionBuilder={props.isSubmissionBuilder}
    >
      <UserSelect
        value={value}
        onChange={props.onChange}
        name={props.name}
        required={props.required && !props.disabled}
        label={props.schema.title}
        error={props.rawErrors?.join(", ")}
        disabled={props.disabled}
        tooltip={props.uiSchema?.["ui:tooltipText"]}
        helperText={props.uiSchema?.["ui:helperText"]}
        placeholder={props.uiSchema?.["ui:placeholder"]}
        includeUsers={includeUsers}
        includePublicUsers={includePublicUsers}
        userGroups={userGroups}
      />
    </Input>
  );
};
